import DetailPoints from "../DetailPoints";
import React, { useState } from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import { FaCalendarAlt, FaGlobe } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import Column from "components/ui/layout/column/column";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import DropDown from "components/ui/controls/drop-down/drop-down";

const PointRci = (props) => {
  const { resultRetraite, ClientConjoint } = props;
  const context = useContext(AppContext);
  const InitialAnneeAcquisition = () => {
    const dt = new Date();

    return dt.getFullYear() - 2;
  };
  let [openModal, setOpenModal] = useState(false);
  return (
    <>
      
      {context.state["Carriere" + ClientConjoint].filter(
        (Carriere) =>
          Carriere.Nature === "RsiCommercant" || Carriere.Nature === "RsiArtisan" || Carriere.Nature === "MicroRSI" || Carriere.Nature === "MicroBIC" || Carriere.Nature === "MicroBNC"
      ).length > 0 && (
        <div className="card">
          <div className="category-column">RCI</div>
          <div
            className="value-column"
            onClick={() => {
              setOpenModal(true);
            }}
          >
            <TextField
              value={context.state["TableauPoints" + ClientConjoint].RetraiteTotalRCI}
              readOnly
              style={{ cursor: "pointer", color: "#1f2937", backgroundColor: "white" }}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
          </div>
          <div className="value-column">
            <DropDown
              value={context.state["TableauPoints" + ClientConjoint].AnneeFinRsiComp}
              onChange={(e) => {
                context.handlePointRetraite(ClientConjoint, "AnneeFinRsiComp", e);
                props.CalculRetraite();
              }}
              options={[
                { value: InitialAnneeAcquisition(), label: InitialAnneeAcquisition() },
                { value: InitialAnneeAcquisition() + 1, label: InitialAnneeAcquisition() + 1 },
              ]}
              normal
            />
          </div>
          <div className="value-column">
            <TextField
              value={resultRetraite?.InfosRetraite?.RCI?.General?.PointCalcule === undefined ? 0 : resultRetraite?.InfosRetraite?.RCI?.General?.PointCalcule}
              disabled={true}
              dataType="ufloat"
              format={{ thousands: " ", precision: 2, decimal: "," }}
              normal
            />
            <DetailPoints caisse="RCI" regime="Complementaire" champ="PointCalcule" libelle="RCI" />
          </div>
        </div>
      )}
      <Modal
        width="30%"
        height="55%"
        title="POINTS RSI"
        icon={<FaGlobe />}
        visible={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <Column fill>
                  <CardBox>
                    <Column fill>
                      {context.state["Carriere" + ClientConjoint].filter((Carriere) => Carriere.Nature === "RsiArtisan").length > 0 && (
                        <>
                          <Row>
                            <CardBoxHeader>RSI ARTISAN</CardBoxHeader>
                          </Row>
                          <Row>
                            <Column>
                              <TextField
                                labelIcon={<FaCalendarAlt />}
                                label="Avant 1979"
                                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompRsiArtisanAvant1979}
                                onChange={context.handleModalPoint(ClientConjoint, "RetraiteCompRsiArtisanAvant1979")}
                                dataType="ufloat"
                                format={{ thousands: " ", precision: 2, decimal: "," }}
                                normal
                              />
                            </Column>
                          </Row>
                          <Row>
                            <Column>
                              <TextField
                                labelIcon={<FaCalendarAlt />}
                                label="Avant 1997"
                                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompRsiArtisanAvant1997}
                                onChange={context.handleModalPoint(ClientConjoint, "RetraiteCompRsiArtisanAvant1997")}
                                dataType="ufloat"
                                format={{ thousands: " ", precision: 2, decimal: "," }}
                                normal
                              />
                            </Column>
                          </Row>
                          <Row>
                            <Column>
                              <TextField
                                labelIcon={<FaCalendarAlt />}
                                label="Entre 1997 et 2012"
                                value={context.state["TableauPoints" + ClientConjoint].RetraiteCompRsiArtisanApres1997}
                                onChange={context.handleModalPoint(ClientConjoint, "RetraiteCompRsiArtisanApres1997")}
                                dataType="ufloat"
                                format={{ thousands: " ", precision: 2, decimal: "," }}
                                normal
                              />
                            </Column>
                          </Row>
                        </>
                      )}
                      {context.state["Carriere" + ClientConjoint].filter(
                        (Carriere) => Carriere.Nature === "RsiCommercant" || Carriere.Nature === "MicroRSI" || Carriere.Nature === "MicroBIC" || Carriere.Nature === "MicroBNC"
                      ).length > 0 && (
                        <>
                          <Row tpad>
                            <CardBoxHeader>RSI COMMERCANT</CardBoxHeader>
                          </Row>
                          <Row>
                            <Column>
                              <TextField
                                labelIcon={<FaCalendarAlt />}
                                label="Avant 2013"
                                value={context.state["TableauPoints" + ClientConjoint].PointRetraiteCompRsiCommercantAvant2013}
                                onChange={context.handleModalPoint(ClientConjoint, "PointRetraiteCompRsiCommercantAvant2013")}
                                dataType="ufloat"
                                format={{ thousands: " ", precision: 2, decimal: "," }}
                                normal
                              />
                            </Column>
                          </Row>
                        </>
                      )}
                      <>
                        <Row tpad>
                          <CardBoxHeader>RCI</CardBoxHeader>
                        </Row>
                        <Row>
                          <Column>
                            <TextField
                              labelIcon={<FaCalendarAlt />}
                              label={"Entre 2013 et " + context.state.TableauPoints.AnneeFinRsiComp}
                              value={context.state["TableauPoints" + ClientConjoint].RetraiteCompRCI}
                              onChange={context.handleModalPoint(ClientConjoint, "RetraiteCompRCI")}
                              dataType="ufloat"
                              format={{ thousands: " ", precision: 2, decimal: "," }}
                              normal
                            />
                          </Column>
                        </Row>
                      </>
                    </Column>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: (evt) => {
                setOpenModal(false);
              },
            },
          }}
        />
      </Modal>
    </>
  );
};
export default PointRci;
